function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["type"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var PREFERRED_FORMAT = 'image/png';
var findPreferredFormat = function findPreferredFormat(formats) {
  return formats.find(function (f) {
    return f.toLowerCase().includes(PREFERRED_FORMAT);
  });
};

// see https://github.com/openlayers/openlayers/blob/v6.6.1/src/ol/source/WMTS.js#L341-L588
// for how OL parses the JSON and what it expects to find in it
export var formatCapabilitiesForOpenLayers = function formatCapabilitiesForOpenLayers(_ref) {
  var tileMatrixSet = _ref.tileMatrixSet,
    id = _ref.id,
    name = _ref.name,
    formats = _ref.formats,
    _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? [] : _ref$styles,
    _ref$resourceUrls = _ref.resourceUrls,
    resourceUrls = _ref$resourceUrls === void 0 ? [] : _ref$resourceUrls;
  var imageFormat = findPreferredFormat(formats);
  // openlayers uses the first format on the list
  // sort formats in a way where preferred image format is first on the list
  var sortedFormatsForOl = [imageFormat];
  // add other formats after it just in case
  formats.filter(function (f) {
    return f !== imageFormat;
  }).forEach(function (f) {
    return sortedFormatsForOl.push(f);
  });
  return {
    Contents: {
      Layer: [{
        Identifier: id || name,
        TileMatrixSetLink: [{
          TileMatrixSet: tileMatrixSet.identifier
        }],
        Style: styles.map(function (s) {
          return {
            Identifier: s.name
          };
        }),
        ResourceURL: resourceUrls.map(function (item) {
          var type = item.type,
            rest = _objectWithoutProperties(item, _excluded);
          return _objectSpread(_objectSpread({}, rest), {}, {
            resourceType: type
          });
        }),
        Format: sortedFormatsForOl
      }],
      TileMatrixSet: [{
        Identifier: tileMatrixSet.identifier,
        SupportedCRS: tileMatrixSet.projection,
        TileMatrix: Object.values(tileMatrixSet.matrixIds).map(function (item) {
          return {
            Identifier: item.identifier,
            MatrixWidth: item.matrixWidth,
            MatrixHeight: item.matrixHeight,
            ScaleDenominator: item.scaleDenominator,
            TopLeftCorner: [item.topLeftCorner.lon, item.topLeftCorner.lat],
            TileWidth: item.tileWidth,
            TileHeight: item.tileHeight
          };
        })
      }]
    }
  };
};